<style>
  main {
    display: flex;
    flex-flow: column;
  }
  div {
    justify-content:  center;
  }
  img {
    max-height: 4em;
    margin: 0.2em;
  }
</style>

<script>
  import { onMount } from 'svelte';
  import config from '../config';
  import { config_values, dev, meteo_data, meteo_data_updated } from './store';
  import ConfigPanel from './comp/ConfigPanel.svelte';
  import MeteoPanel from './comp/MeteoPanel.svelte';
  
  import 'leaflet/dist/leaflet-src';
  import 'leaflet/dist/leaflet.css';
  
  function update_meteo() {
    let updated_at = new Date();
    let now = Math.floor(Date.now() / 1000);
    if ($config_values.provider && $config_values.location) {
      // adding providers
      let providers = [];
      for (let key of Object.keys($config_values.provider)) {
        if ($config_values.provider[key].visible) {
          providers.push($config_values.provider[key].id);
        }
      }
      
      // adding locations
      let locations = [];
      for (let key of Object.keys($config_values.location)) {
        if ($config_values.location[key].visible) {
          locations.push($config_values.location[key].id);
        }
      }
      
      // removing not used data
      for (let prov_id of Object.keys($meteo_data)) {
        if (!$meteo_data[prov_id]) {
          continue;
        }
        if (!providers.includes(prov_id)) {
          delete $meteo_data[prov_id];
          continue;
        }
        for (let loc_id of Object.keys($meteo_data[prov_id])) {
          if (!locations.includes(loc_id)) {
            delete $meteo_data[prov_id][loc_id];
          }
        }
      }
      
      // checking meteo data
      for (let prov_id of providers) {
        for (let loc_id of locations) {
          if ($meteo_data[prov_id] && $meteo_data[prov_id][loc_id]) {
            if (now - $meteo_data[prov_id][loc_id].updated_at > config.update_frequency) {
              set_meteo_data(prov_id, loc_id);
            }
          } else {
            set_meteo_data(prov_id, loc_id);
          }
        }
      }
      if (dev) {console.log('Checked meteo data');}
      $meteo_data_updated = updated_at.toISOString().slice(0,16).replace('T', ' ');
    }
    setTimeout(update_meteo, config.update_frequency * 1000);
  }
  
  async function set_meteo_data(provider, location) {
    if (!$meteo_data[provider]) {
      $meteo_data[provider] = {};
    }
    let now = Math.floor(Date.now() / 1000);
    $meteo_data[provider][location] = {data: {}, updated_at: now}
    const resource = `${config.api_url}/${provider}/current/location/${location}.json`;
    let request = {
      cache: 'no-cache',
      method: 'GET',
      mode: 'cors',
    };
    const response = await fetch(resource, request);
    if (dev) {console.log(`GET ${resource}`);}
    if (!response.ok) {
      console.error(`Error ${response.status} while executing request ${resource}`);
      return;
    }
    const resp_data = await response.json();
    if (resp_data && resp_data.forecast) {
      // console.log(`Updated meteo data for ${location}`)
      $meteo_data[provider][location].data = resp_data;
    } else {
      console.error(`Invalid forecast data for request ${resource}`);
    }
  }
  
  function save_config() {
    if ($config_values && $config_values.location) {
      if (dev) {console.log('Saving config');}
      localStorage.setItem('meteo_config', JSON.stringify($config_values));
    }
  }
  
  function load_config() {
    let config_raw = JSON.parse(localStorage.getItem('meteo_config'));
    if (config_raw && config_raw.location) {
      if (dev) {console.log('Restoring config');}
      $config_values = config_raw;
    }
  }
  
  load_config();
  
  $: {
    $config_values;
    save_config();
    update_meteo();
  }
</script>

<main>
  <div class='horiz-always'>
    <img src='zs-logo.png' alt='Zemnieku Saeima logo'>
  </div>
  <ConfigPanel/>
  <MeteoPanel/>
</main>
